import { registerBlockType } from '@wordpress/blocks';
import Edit from './edit';
import metadata from './block.json';

const ratingIcon = (
    <svg
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M12.5 2.5C12.8906 2.52604 13.1771 2.70833 13.3594 3.04688L16.0156 8.55469L21.9922 9.45312C22.3828 9.50521 22.6432 9.71354 22.7734 10.0781C22.8776 10.4427 22.7995 10.7552 22.5391 11.0156L18.2031 15.3125L19.2188 21.4062C19.2708 21.7708 19.1406 22.0703 18.8281 22.3047C18.4896 22.513 18.1641 22.5391 17.8516 22.3828L12.5 19.5312L7.10938 22.3828C6.79688 22.5391 6.48438 22.513 6.17188 22.3047C5.85938 22.0703 5.71615 21.7708 5.74219 21.4062L6.79688 15.3125L2.46094 11.0156C2.20052 10.7552 2.1224 10.4427 2.22656 10.0781C2.35677 9.71354 2.60417 9.50521 2.96875 9.45312L8.98438 8.55469L11.6406 3.04688C11.8229 2.70833 12.1094 2.52604 12.5 2.5ZM12.5 5.58594L10.4297 9.80469C10.2995 10.0911 10.0651 10.2734 9.72656 10.3516L5.11719 11.0156L8.47656 14.3359C8.6849 14.5703 8.77604 14.8438 8.75 15.1562L7.92969 19.8438L12.0703 17.6562C12.3568 17.5 12.6432 17.5 12.9297 17.6562L17.0312 19.8438L16.25 15.1562C16.1979 14.8438 16.2891 14.5703 16.5234 14.3359L19.8828 11.0156L15.2734 10.3516C14.9349 10.2734 14.7005 10.0911 14.5703 9.80469L12.5 5.58594Z"
            fill="#FF9500"
        />
    </svg>
);

registerBlockType(metadata.name, {
    icon: ratingIcon,
    title: metadata.title,
    edit: Edit,
});
